// extracted by mini-css-extract-plugin
module.exports = {"footer":"AddModal_footer__1JaUE"};